/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import CardMedia from '@mui/material/CardMedia';

import GeneralTabs from 'common/components/navigation/actionsTab/tabs';
import { BASE_S3 } from 'config/consts';
import {
  DomPurifyContentContainer,
  GeneralTitle,
} from './styles';
import { ImagePreviewContainer } from '../sections/information';
import ActivityButton from 'common/components/buttons/activityButton';
import VoucherModal from './VoucherModal';

export default class TanqueCheioPreview extends Component {
  constructor(props) {
    super(props);
    this.state = { tab: 'activity' };
  }

  handleTabChange = (_event, newTab) => {
    this.setState({ tab: newTab });
  };

  getImagePath() {
    const { image, station_images, stations_field } = this.props.formValues;
    
    // Primeiro, verificar se há uma imagem principal definida
    if (image) {
      if (typeof image === 'string' && image.includes('base64')) {
        return image;
      }
      if (typeof image === 'string') {
        return `${BASE_S3}/${image}`;
      }
      if (image.path && image.saved_name) {
        return `${BASE_S3}/${image.path}/${image.saved_name}`;
      }
    }

    if (station_images && stations_field && stations_field.length > 0) {
      const stationWithImage = stations_field.find(station => station_images[station.id]);
      if (stationWithImage) {
        const stationImageId = station_images[stationWithImage.id];
        return `${BASE_S3}/${stationImageId}`;
      }
    }
    
    return '';
  }

  renderGeneralTab() {
    const { formValues } = this.props;
    const label = formValues.click_me_label || 'Ver oferta';

    return (
      <Box>
        <DomPurifyContentContainer
          sx={{ mb: 2 }}
          dangerouslySetInnerHTML={{ __html: formValues.description || '' }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <ActivityButton
            presential_course
            no_disable
            label={label}
            color="#287576"
            checkbox_text="Aceito compartilhar os meus dados com o gestor da plataforma."
          />
        </Box>
      </Box>
    );
  }

  renderRulesTab() {
    const { formValues } = this.props;
    return (
      <DomPurifyContentContainer
        dangerouslySetInnerHTML={{ __html: formValues.voucher_regulation || '' }}
      />
    );
  }

  renderActivityTab() {
    const imagePath = this.getImagePath();

    return (
      <Box>
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <ImagePreviewContainer imagePath={imagePath} />
        </Box>
        <Box sx={{ mb: 2 }}>
          <GeneralTitle isPreview>
            {this.props.formValues.name}
          </GeneralTitle>
        </Box>
        <GeneralTabs
          start={this.renderGeneralTab()}
          rules={this.renderRulesTab()}
        />
      </Box>
    );
  }

  renderCardTab() {
    const imagePath = this.getImagePath();
    const { formValues } = this.props;
    const label = formValues.click_me_label || 'Ver oferta';

    return (
      <Card sx={{ maxWidth: 345, mx: 'auto' }}>
        <CardMedia
          component="img"
          height="180"
          image={imagePath}
          alt={formValues.name}
        />
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="subtitle1" gutterBottom>
            {formValues.name}
          </Typography>
          <DomPurifyContentContainer
            sx={{ mb: 2, textAlign: 'left' }}
            dangerouslySetInnerHTML={{ __html: formValues.description || '' }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component="button"
              sx={{
                backgroundColor: '#287576',
                color: '#fff',
                border: 0,
                borderRadius: 1,
                px: 4,
                py: 1.2,
                fontSize: 16,
                cursor: 'pointer',
                '&:hover': { backgroundColor: '#287576' },
              }}
            >
              {label}
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  }

  render() {
    const { activeSection, formValues } = this.props;

    // Preview do voucher quando estiver na aba Litros e Preços (índice 2)
    if (activeSection === 2) {
      return (
        <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Preview do Voucher
          </Typography>
          <VoucherModal
            colors={formValues.colors}
            formValues={formValues}
          />
        </Box>
      );
    }

    // Preview padrão de Atividade / Card
    const { tab } = this.state;
    return (
      <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Preview
        </Typography>

        <Tabs
          value={tab}
          onChange={this.handleTabChange}
          variant="fullWidth"
          TabIndicatorProps={{
            sx: {
              height: 3,
              borderRadius: 3,
              backgroundColor: 'primary.main',
              bottom: 0,
            },
          }}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            mb: 2,
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              color: 'text.secondary',
            },
            '& .Mui-selected': {
              color: 'primary.main',
            },
          }}
        >
          <Tab label="ATIVIDADE" value="activity" />
          <Tab label="CARD" value="card" />
        </Tabs>

        {tab === 'activity' ? this.renderActivityTab() : this.renderCardTab()}
      </Box>
    );
  }
}

TanqueCheioPreview.propTypes = {
  formValues: PropTypes.shape({
    name:               PropTypes.string,
    image:              PropTypes.oneOfType([
                          PropTypes.string,
                          PropTypes.shape({
                            path:       PropTypes.string,
                            saved_name: PropTypes.string,
                          }),
                        ]),
    description:        PropTypes.string,
    click_me_label:     PropTypes.string,
    colors:             PropTypes.any,
    voucher_regulation: PropTypes.string,
    station_images:     PropTypes.object,
    stations_field:     PropTypes.array,
  }).isRequired,
  activeSection: PropTypes.number.isRequired,
};
